import React from 'react'
import { Table as UxTable, Form } from '@deere/ux.uxframe-react'
import { containsCheckBoxAnswer, findAnswerIndex, getTranslation } from '../utils/utils';
import { useTranslation } from "react-i18next";

export default function TableCustom({ questions, answers, updateAnswer, section, checkedProprietary }) {
    const { t } = useTranslation();
    const questionTitle = questions ? questions.find(q => q.type === 'FLEX_TITLE') : null;
    const listQuestions = questions ? questions.filter(q => q.type === 'FLEX_TABLE') : null;
    const colNames = listQuestions[0] ? [getTranslation(listQuestions[0], 'text'), ...listQuestions[0].dependentQuestions.map(q => getTranslation(q, 'text'))] : null;

    const isOtherChecked = ( question ) => {
        let isChecked = false;
        let parent = answers.find(qu => parseInt(qu.questionId) === parseInt(question.idQuestionDepends));
        if(parent && containsCheckBoxAnswer(question.idSelectionDependson.toString(),parent.answer)){
            isChecked = true;
        }
        return isChecked;
    }

    const getValue = ( question ) => {
        if(isOtherChecked(question)) {
            if(findAnswerIndex(question.id, answers) >= 0) {
                return answers[findAnswerIndex(question.id, answers)].answer;
            }
        }
        return '';
    }

    function createDependentCol(question) {
        if (question.type === 'OPTION') {
            return <td className='p-1' key={question.id}>
                <Form.Control as='select' required={!checkedProprietary} className="custom-select" onChange={(e) => updateAnswer(e, question.id)}
                    name={`${section}-${question.id}`}
                    value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}>
                    <option value=''>{t('lbl_dropdown_select')}</option>
                    {question.selections ? question.selections.sort((a, b) => (parseInt(a.value) > parseInt(b.value)) ? 1 : -1).map(opt => <option key={opt.id} value={opt.value}>{getTranslation(opt, 'text')}</option>) : null}
                </Form.Control>
                <div className="invalid-feedback">
                    {t('bs_required')}
                </div>
            </td>
        }

        if (question.type === 'OPEN') {
            return <td className='p-1' key={question.id}>
                   <Form.Control
                        required={true}
                        disabled={!isOtherChecked(question)}
                        onChange={e => updateAnswer(e, question.id)}
                        value={getValue(question)}
                        name={`${section}-${question.id}`}
                    />
                   <div className="invalid-feedback">
                       {t('bs_required')}
                   </div>
               </td>
        }
        return <></>;
    }
    return (
        <>
            <UxTable striped hover size="sm" >
                <caption>{getTranslation(questionTitle, 'text')}</caption>
                <thead>
                    <tr>
                        {
                            colNames ? colNames.map(qt =>
                                <th scope="col" className="p-1 text-center" key={qt}>{qt}</th>
                            ) : <></>
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        listQuestions.map((q, index) =>
                            q.selections[0] &&
                            <tr key={index}>
                                <td className='p-1'>
                                    {q.selections[0].text}
                                </td>
                                {q.dependentQuestions.sort((a, b) => (a.id > b.id) ? 1 : -1).map((dq, dIndex) => createDependentCol(dq))}
                            </tr>)
                    }
                </tbody>
            </UxTable>
        </>
    )
}

